// Types for better type safety and autocompletion
export interface CodeArticle {
  number: string;
  header: string | null;
  text: string;
  subArticles?: { [key: string]: CodeArticle };
  parent?: string;
  category?: string;
}

export interface ArticleSearchResult {
  articleNumber: string;
  article: CodeArticle;
  relevanceScore: number;
}

// Main code articles data
export const codeArticles: { [key: string]: CodeArticle } = {
  "1.1": {
    number: "1.1",
    header: "Reclame in ruimste zin des woords",
    text: "Deze Gedragscode heeft - in de ruimste zin des woords - betrekking op de reclame voor en informatie over geneesmiddelen, dat wil zeggen zowel mondeling, schriftelijk, met behulp van audiovisuele methodieken, via tentoonstellingen, congressen en symposia als op andere wijze."
  },
  "1.2": {
    number: "1.2",
    header: "Verantwoorde omgang vergunninghouders",
    text: "De Gedragscode stelt normen aan activiteiten die te maken hebben met een verantwoorde gang van zaken bij de omgang tussen vergunninghouders en beroepsbeoefenaren, zorgprofessionals, patiëntenorganisaties en andere betrokkenen en die direct of indirect invloed hebben op het voorschrijven, ter hand stellen en/of gebruiken van geneesmiddelen. Daarbij kan het gaan om het verstrekken van algemene informatie over geneesmiddelen, het verlenen van gastvrijheid tijdens een bijeenkomst of manifestatie, het verstrekken van/vragen om premies of voordelen in geld of natura, het verstrekken van monsters van geneesmiddelen en marktonderzoek inzake het gebruik van geregistreerde geneesmiddelen."
  },
  "2.1": {
    number: "2.1",
    header: "Toezicht op naleving",
    text: "Het toezicht op de naleving van deze Gedragscode is opgedragen aan de Keuringsraad alsmede aan de door de Stichting Code Geneesmiddelenreclame in het leven geroepen Codecommissie en Commissie van Beroep, overeenkomstig de daarvoor vastgestelde bepalingen."
  },
  "2.2": {
    number: "2.2",
    header: "Meewerkingsplicht",
    text: "De vergunninghouder en de beroepsbeoefenaar is verplicht aan het toezichthoudende orgaan, bedoeld in artikel 2.1, alle medewerking te verlenen die het redelijkerwijs nodig heeft bij de uitoefening van zijn taak."
  },
  "3.1": {
    number: "3.1",
    header: "Begripsbepalingen",
    introduction: "Voor de toepassing van deze Gedragscode wordt verstaan onder:",
    subsections: {
      "a": "Geneesmiddelen: geneesmiddelen vallende onder de Geneesmiddelenwet, alsmede bloedproducten, vallende onder de Wet inzake Bloedvoorziening.",
      "b": "Publieksreclame: reclame voor een geneesmiddel die, gezien haar inhoud en de wijze waarop zij wordt geuit, kennelijk ook voor anderen dan beroepsbeoefenaren is bestemd.",
      "c": "De Wet: de Geneesmiddelenwet en/of de Wet inzake Bloedvoorziening.",
      "d": "Beroepsbeoefenaren: een ieder die de bevoegdheid heeft om receptgeneesmiddelen voor te schrijven of ter hand te stellen.",
      "e": "Vergunninghouders: houders van een handelsvergunning of van een vergunning als bedoeld in artikel 18 van de Geneesmiddelenwet alsmede houders van een vergunning als bedoeld in artikel 15 van de Wet inzake Bloedvoorziening.",
      "f": "Artsenbezoekers: personen wier hoofdtaak het is om - in opdracht van een vergunninghouder en in persoonlijk contact met beroepsbeoefenaren - medisch-farmaceutische voorlichting te geven aan en te overleggen met beroepsbeoefenaren over de toepassing van geneesmiddelen ten behoeve van de diagnostiek en/of de behandeling van patiënten.",
      "g": "Vertegenwoordigers: personen die – in opdracht van een vergunninghouder – beroepsbeoefenaren bezoeken voor hoofdzakelijk andere doeleinden dan medisch-farmaceutische voorlichting.",
      "h": "Reclame: iedere openbare en/of systematische directe dan wel indirecte aanprijzing van geneesmiddelen en daarmee samenhangende diensten of denkbeelden, daaronder begrepen het aanbieden of vragen van diensten of goederen in de omgang tussen vergunninghouders en beroepsbeoefenaren.",
      "i": "Financiële relatie: het in het vooruitzicht stellen, aanbieden of toekennen van geld of op geld waardeerbare diensten of goederen.",
      "j": "Gunstbetoon: financiële relatie met het kennelijke doel het voorschrijven, ter hand stellen of gebruiken van een geneesmiddel te bevorderen.",
      "k": "SPC: samenvatting van productkenmerken zoals deze is goedgekeurd door het College ter Beoordeling van Geneesmiddelen dan wel het Europese Geneesmiddelenbureau."
    },
    text: "Voor de toepassing van deze Gedragscode wordt verstaan onder:\n\na. Geneesmiddelen: geneesmiddelen vallende onder de Geneesmiddelenwet, alsmede bloedproducten, vallende onder de Wet inzake Bloedvoorziening.\nb. Publieksreclame: reclame voor een geneesmiddel die, gezien haar inhoud en de wijze waarop zij wordt geuit, kennelijk ook voor anderen dan beroepsbeoefenaren is bestemd.\nc. De Wet: de Geneesmiddelenwet en/of de Wet inzake Bloedvoorziening.\nd. Beroepsbeoefenaren: een ieder die de bevoegdheid heeft om receptgeneesmiddelen voor te schrijven of ter hand te stellen.\ne. Vergunninghouders: houders van een handelsvergunning of van een vergunning als bedoeld in artikel 18 van de Geneesmiddelenwet alsmede houders van een vergunning als bedoeld in artikel 15 van de Wet inzake Bloedvoorziening.\nf. Artsenbezoekers: personen wier hoofdtaak het is om - in opdracht van een vergunninghouder en in persoonlijk contact met beroepsbeoefenaren - medisch-farmaceutische voorlichting te geven aan en te overleggen met beroepsbeoefenaren over de toepassing van geneesmiddelen ten behoeve van de diagnostiek en/of de behandeling van patiënten.\ng. Vertegenwoordigers: personen die – in opdracht van een vergunninghouder – beroepsbeoefenaren bezoeken voor hoofdzakelijk andere doeleinden dan medisch-farmaceutische voorlichting.\nh. Reclame: iedere openbare en/of systematische directe dan wel indirecte aanprijzing van geneesmiddelen en daarmee samenhangende diensten of denkbeelden, daaronder begrepen het aanbieden of vragen van diensten of goederen in de omgang tussen vergunninghouders en beroepsbeoefenaren.\ni. Financiële relatie: het in het vooruitzicht stellen, aanbieden of toekennen van geld of op geld waardeerbare diensten of goederen.\nj. Gunstbetoon: financiële relatie met het kennelijke doel het voorschrijven, ter hand stellen of gebruiken van een geneesmiddel te bevorderen.\nk. SPC: samenvatting van productkenmerken zoals deze is goedgekeurd door het College ter Beoordeling van Geneesmiddelen dan wel het Europese Geneesmiddelenbureau."
  },
  "4.1": {
    number: "4.1",
    header: "Verantwoord gedrag in onderling verkeer vergunninghouders en beroepsbeoefenaren",
    text: "Onverminderd de ter zake geldende wettelijke bepalingen en onverminderd ook het elders in deze Gedragscode bepaalde, dragen vergunninghouders en beroepsbeoefenaren zorg voor een verantwoord gedrag in hun onderlinge verkeer. Deze zorg betreft in het bijzonder de verplichting om dat gedrag in overeenstemming te doen zijn met de belangen van de eindverbruiker alsmede van de volksgezondheid in het algemeen, waaronder begrepen het feit dat een belangrijk deel van de kosten van geneesmiddelen uit, in het kader van collectieve voorzieningen opgebrachte, fondsen wordt gedekt. Vergunninghouders en beroepsbeoefenaren zijn transparant over hun relaties en zijn daarvoor aanspreekbaar."
  },
  "4.2": {
    number: "4.2",
    header: "Conflicten beroepseed en onoorbare verplichtingen vermijden",
    text: "Vergunninghouders en beroepsbeoefenaren vermijden bij hun onderlinge verkeer dat zij op enigerlei wijze in conflict raken met hun beroepseed of met uit andere hoofde in het kader van de uitoefening van hun beroep of bedrijf op hen rustende verplichtingen, dan wel dat zij zich op onoorbare wijze jegens elkaar verplicht zouden voelen."
  },
  "4.3": {
    number: "4.3",
    header: "Interne controle op correcte naleving",
    text: "Vergunninghouders en beroepsbeoefenaren richten hun activiteiten met betrekking tot geneesmiddelen zodanig in dat een correcte naleving van deze Gedragscode alsmede een adequate controle op die naleving is gewaarborgd, en zij onthouden zich van ieder handelen of nalaten dat, hoewel daarin niet uitdrukkelijk is voorzien in deze Gedragscode, in strijd is met de geest of de strekking daarvan."
  },
  "5.1": {
    number: "5.1",
    header: "Algemeen",
    text: "Onverminderd het ter zake bepaalde in of krachtens de Wet en onverminderd ook andere ter zake geldende wettelijke bepalingen geschiedt geneesmiddelenreclame in Nederland in overeenstemming met deze Gedragscode."
  },
  "5.1.2": {
    number: "5.1.2",
    header: "Buiten reikwijdte Code",
    text: "Niet onder de Gedragscode vallen:\na. etikettering en bijsluiters van geneesmiddelen;\nb. brieven of e-mails, eventueel vergezeld van documentatie waarmee geen reclame-doeleinden worden nagestreefd, ter inwilliging van een specifiek verzoek om informatie over een bepaald geneesmiddel;\nc. concrete informatie en de bijbehorende documentatie, bijvoorbeeld over wijziging van de verpakking, waarschuwingen voor ongewenste bijwerkingen in het kader van de geneesmiddelenbewaking, en over verkoop- en prijslijsten voor zover daarin geen gegevens over het geneesmiddel staan; en\nd. informatie betreffende de volksgezondheid of menselijke ziekten, voor zover die geen verwijzing, zelfs niet indirect, naar een geneesmiddel bevat."
  },
  "5.1.3": {
    number: "5.1.3",
    header: "Onderscheid tussen informatie en reclame",
    text: "Reclame kenmerkt zich door het aanprijzende karakter van de uiting. Of er sprake is van informatie dan wel reclame moet van geval tot geval worden beoordeeld, waarbij de volgende factoren een rol (kunnen) spelen:\na. de geadresseerde;\nb. de inhoud, de presentatie en de opmaak van de uiting;\nc. de context van de uiting."
  },
  "5.2.1": {
    number: "5.2.1",
    header: "Eisen aan reclame",
    text: "Bij geneesmiddelenreclame, of deze nu mondeling, schriftelijk, via audio en/of visuele methodieken, dan wel op andere wijze geschiedt, dient het navolgende in acht te worden genomen."
  },
  "5.2.1.1": {
    number: "5.2.1.1",
    header: "Verbod reclame ongeregistreerde geneesmiddelen en uitzondering",
    text: "a. Reclame met betrekking tot een geneesmiddel waarvoor geen handelsvergunning is verleend, is verboden.\nb. Als uitzondering op het in het vorige lid omschreven verbod geldt dat reclame voor een geneesmiddel waarvoor geen handelsvergunning is verleend binnen een internationale wetenschappelijke context is toegestaan, indien wordt voldaan aan de volgende voorwaarden:\n- de reclame-uiting wordt gedaan in een wetenschappelijk tijdschrift met een onmiskenbaar internationaal karakter dan wel in het kader van een bijeenkomst die qua opzet daadwerkelijk een internationaal karakter heeft en waarvan een belangrijk deel van de sprekers en deelnemers afkomstig zijn uit andere landen dan Nederland; en\n- de reclame-uiting is wat woord en inhoud betreft onmiskenbaar niet op Nederland gericht; en\n- het geneesmiddel waar de reclame-uiting betrekking op heeft is geregistreerd in tenminste één belangrijk geïndustrialiseerd land."
  },
  "5.2.1.2": {
    number: "5.2.1.2",
    header: "Overeenstemming SPC",
    text: "De reclame mag in geen enkel opzicht strijdig zijn met de van overheidswege goedgekeurde SPC van het geneesmiddel als voorgeschreven bij of krachtens de Wet."
  },
  "5.2.1.3": {
    number: "5.2.1.3",
    header: "Verbod op misleiding",
    text: "De reclame dient op een zodanige wijze te geschieden dat het rationele gebruik van de betrokken geneesmiddelen in farmacotherapeutisch opzicht wordt bevorderd en dat degene tot wie de aanprijzing is gericht op generlei wijze wordt misleid."
  },
  "5.2.1.4": {
    number: "5.2.1.4",
    header: "Vormgeving",
    text: "De reclame dient een zodanige vormgeving te vertonen dat het promotionele karakter daarvan kan worden onderkend door degene tot wie de reclame is gericht."
  },
  "5.2.1.5": {
    number: "5.2.1.5",
    header: "Goede smaak en fatsoen",
    text: "De reclame dient ook overigens in overeenstemming te zijn met de Wet en zowel qua tekst als qua presentatie te voldoen aan de geldende normen van goede smaak en fatsoen, die zowel ten opzichte van degene tot wie de reclame is gericht als ten opzichte van de branchegenoten in acht dienen te worden genomen."
  },
  "5.2.2": {
    number: "5.2.2",
    header: "Criteria voor reclame",
    text: "Bij de beoordeling van de vraag of een reclame-uiting in overeenstemming is met de hierboven vermelde gedragsregels, dient te worden nagegaan of de navolgende criteria in acht zijn genomen."
  },
  "5.2.2.1": {
    number: "5.2.2.1",
    header: "Waardigheid en omzichtigheid",
    text: "Is de waardigheid en omzichtigheid betracht welke in overeenstemming is met de aard van het product."
  },
  "5.2.2.2": {
    number: "5.2.2.2",
    header: "Vermijden vage termen en superlatieven",
    text: "Is, ten einde het rationele gebruik van het geneesmiddel te bevorderen, vermeden om vage termen of superlatieven te gebruiken of anderszins te overdrijven over de eigenschappen van het betreffende geneesmiddel."
  },
  "5.2.2.3": {
    number: "5.2.2.3",
    header: "Accuraat, juist en controleerbaar",
    text: "Is de reclame-uiting in relatie tot de totaliteit van de reclame voor het betreffende geneesmiddel accuraat, actueel, waarheidsgetrouw en in zijn onderdelen juist en controleerbaar."
  },
  "5.2.2.4": {
    number: "5.2.2.4",
    header: "Werking geneesmiddel; indicaties, klinische effectiviteit",
    text: "Geeft de totaliteit van tot beroepsbeoefenaren gerichte reclame een zo volledig en nauwkeurig mogelijk beeld van de werking van het geneesmiddel. Daarbij zijn in ieder geval te betrekken de indicaties en de klinische effectiviteit volgens de registratiegegevens, alsmede de bijwerkingen en contra-indicaties."
  },
  // Add these articles to your codeArticles object
  "5.3.2": {
    number: "5.3.2",
    header: "Adequate communicatie",
    text: "Artsenbezoekers zijn zodanige gesprekspartners voor beroepsbeoefenaren dat zij een adequate communicatie mogelijk maken met de vergunninghouder die zij vertegenwoordigen.",
    category: "Reclame"
  },
  "5.3.3": {
    number: "5.3.3",
    header: null,
    text: "Artsenbezoekers houden zich bij de reclame aan de in hoofdstuk 5 vermelde gedragsregels.",
    category: "Reclame"
  },
  "5.3.4": {
    number: "5.3.4",
    header: "Ter beschikking stellen SPC",
    text: "Artsenbezoekers houden bij elk bezoek aan een beroepsbeoefenaar van elk geneesmiddel waarvoor zij reclame maken, de SPC van het geneesmiddel ter beschikking. Dat betekent dat de artsenbezoeker de betreffende, meest recente, SPC altijd bij zich dient te hebben om deze op verzoek te kunnen tonen. Ook kan de artsenbezoeker daarvoor verwijzen naar de Geneesmiddelen Informatiebank voor Mensen van het College ter Beoordeling van Geneesmiddelen. Bij de aanprijzing van nieuwe geneesmiddelen dient de betreffende SPC altijd te worden overhandigd.",
    category: "Reclame"
  },
  "5.3.5": {
    number: "5.3.5",
    header: "Maken afspraak",
    text: "Artsenbezoekers beloven geen voordelen en gebruiken geen valse voorwendsels om een afspraak te maken met een beroepsbeoefenaar.",
    category: "Reclame"
  },
  "5.3.6": {
    number: "5.3.6",
    header: "Regels, frequentie, planning bezoeken",
    text: "Artsenbezoekers respecteren de wensen van de beroepsbeoefenaar of de regels van een ziekenhuis en dragen er zorg voor dat de frequentie, tijdsplanning en duur van de bezoeken aan beroepsbeoefenaren of ziekenhuizen, evenals de manier waarop deze bezoeken plaatsvinden, geen overlast veroorzaken.",
    category: "Reclame"
  },
  "5.3.7": {
    number: "5.3.7",
    header: "Voorzorgsmaatregelen m.b.t. diefstal en verlies",
    text: "Artsenbezoekers nemen de nodige voorzorgsmaatregelen met betrekking tot de veiligheid van de geneesmiddelen die zij in hun bezit hebben, zoals tegen diefstal en verlies en met betrekking tot de deugdelijke bewaring in verband met de kwaliteit.",
    category: "Reclame"
  },
  "5.3.8": {
    number: "5.3.8",
    header: "Reclame per telefoon",
    text: "Mondelinge reclame via de telefoon is niet toegestaan, tenzij op basis van een eerdere afspraak met de betreffende beroepsbeoefenaar.",
    category: "Reclame"
  },
  "5.3.9": {
    number: "5.3.9",
    header: "Rapportage bezoeken en administratie",
    text: "Artsenbezoekers rapporteren aan de vergunninghouder die zij vertegenwoordigen, ieder bezoek aan een beroepsbeoefenaar onder vermelding van het geneesmiddel of de geneesmiddelen waarvoor zij reclame hebben gemaakt, de datum van het bezoek en de tijdens het bezoek gepresenteerde schriftelijke informatie. Vergunninghouders houden deze rapportage gedurende vijf (5) jaar ter beschikking van de autoriteiten en instanties die met het toezicht op de geneesmiddelenreclame zijn belast als onderdeel van de administratie bedoeld in artikel 5.2.3.1. Bovendien dragen vergunninghouders er zorg voor dat deze administratie wordt ingericht conform de Wet bescherming persoonsgegevens en de bedoelde rapportage ter beschikking wordt gesteld aan de betrokken beroepsbeoefenaar overeenkomstig het bepaalde in de Wet bescherming persoonsgegevens.",
    category: "Reclame"
  },
  "5.3.10": {
    number: "5.3.10",
    header: "Informatie van artsen over geneesmiddelen",
    text: "Indien door een beroepsbeoefenaar aan een artsenbezoeker informatie wordt gegeven met betrekking tot het gebruik, de werking en in het bijzonder de bijwerkingen van de geneesmiddelen waarvoor de artsenbezoeker reclame maakt, geeft de artsenbezoeker deze informatie onmiddellijk door aan de in artikel 5.9.1 bedoelde wetenschappelijke dienst van de vergunninghouder die de artsenbezoeker vertegenwoordigt.",
    category: "Reclame"
  },
  "5.3.11": {
    number: "5.3.11",
    header: "Waarborgen door vergunninghouder",
    text: "Vergunninghouders zijn ervoor verantwoordelijk dat de artsenbezoekers die hen vertegenwoordigen zich gedragen conform de onderhavige gedragsregels. Vergunninghouders treffen de nodige maatregelen om te waarborgen dat de artsenbezoekers die hen vertegenwoordigen voldoen aan de in deze Gedragscode gestelde voorwaarden ten aanzien van opleiding, kennis en vaardigheden.",
    category: "Reclame"
  },
  "5.3.12": {
    number: "5.3.12",
    header: "Overeenkomstige toepassing vertegenwoordigers",
    text: "Het bepaalde in de artikelen 5.3.5, 5.3.6 en 5.3.7 is van overeenkomstige toepassing op vertegenwoordigers.",
    category: "Reclame"
  },
  "5.4.1": {
    number: "5.4.1",
    header: "Voorwaarden schriftelijke reclame",
    text: "Iedere tot beroepsbeoefenaren gerichte schriftelijke reclame voldoet aan de in deze Gedragscode gegeven aanwijzingen en vermeldt in ieder geval de volgende informatie in overeenstemming met de SPC: a. de benaming van het geneesmiddel; b. de naam en adres van degene die verantwoordelijk is voor het in de handel brengen; c. de kwalitatieve en kwantitatieve samenstelling van werkzame bestanddelen; d. de farmacotherapeutische groep, voor zover relevant; e. de farmaceutische vorm; f. de voornaamste therapeutische indicaties; g. de belangrijkste bijwerkingen (aan de hand van frequentie en ernst); h. de belangrijkste waarschuwingen (voorzorgsmaatregelen in verband met het voorschrijven en het gebruik); i. de contra-indicaties; en j. de indeling van het geneesmiddel (receptplichtig of niet) met betrekking tot de aflevering; op een plaats en in een lettertype die aan het belang van die informatie recht doet. Indien bij schriftelijke reclame de hier bedoelde informatie een zodanige omvang heeft dat de tekst in redelijkheid niet in een gangbaar formaat is onder te brengen, kan worden verwezen naar de vindplaats van die informatie elders in het betreffende medium.",
    category: "Reclame"
  },
  "5.4.2": {
    number: "5.4.2",
    header: "Herinneringsreclame",
    text: "De criteria bedoeld in artikel 5.4.1 zijn niet van toepassing indien de tot beroepsbeoefenaren gerichte schriftelijke reclame uitsluitend ten doel heeft: a. de benaming van het geneesmiddel in herinnering te brengen en overigens niet meer gegevens bevat dan: - de samenstelling van het geneesmiddel; - de vermelding van de farmacotherapeutische groep; - de naam en adres van degene die voor het in de handel brengen verantwoordelijk is; of b. praktische informatie ter identificatie van het geneesmiddel te verstrekken zonder dat daarbij een farmacotherapeutische claim wordt gelegd. In dat geval zal indien voor het geneesmiddel een internationale generieke benaming bestaat, deze naast de benaming van het geneesmiddel dienen te worden vermeld.",
    category: "Reclame"
  },
  "5.4.3": {
    number: "5.4.3",
    header: "Voorafgaande toetsing door wetenschappelijke dienst",
    text: "Elke schriftelijke uiting wordt, voorafgaand aan de verspreiding, door de wetenschappelijke dienst als bedoeld in artikel 5.9.1 getoetst aan de voorschriften van deze Gedragscode.",
    category: "Reclame"
  },
  "5.5.1": {
    number: "5.5.1",
    header: "Tentoonstellingen en social media",
    text: "Reclame op tentoonstellingen en vakbeurzen of via audio- en/of visuele of andere methodieken (zoals social media) geschiedt, rekening houdende met het specifieke karakter van bedoelde methodieken, in overeenstemming met en in de geest van de hierboven gestelde gedragsregels voor mondelinge en schriftelijke reclame.",
    category: "Reclame"
  },
  "5.6.1": {
    number: "5.6.1",
    header: "Code Publieksreclame voor Geneesmiddelen",
    text: "Onverminderd het bepaalde in deze Gedragscode in het algemeen en het bepaalde in artikel 5.4.3 in het bijzonder, wordt bij publieksreclame de Code Publieksreclame voor Geneesmiddelen in acht genomen. Deze Code vormt een integraal onderdeel van deze Gedragscode en wordt ook aangeduid als CPG.",
    category: "Reclame"
  },
  "5.6.2": {
    number: "5.6.2",
    header: "Publieksreclame en sponsoring",
    text: "Vergunninghouders onthouden zich van sponsoring van activiteiten van derden, indien de tegenprestatie van die derden geheel of ten dele bestaat uit publieksreclame voor geneesmiddelen, waarvan in of krachtens de Wet is bepaald dat deze uitsluitend op recept mogen worden afgeleverd.",
    category: "Reclame"
  },
  "5.7.1": {
    number: "5.7.1",
    header: "Eisen aan informatie",
    text: "Informatie over geneesmiddelen: a. mag niet in strijd zijn met de SPC van het geneesmiddel en de bijsluiter. Informatie over off-label gebruik is toegestaan mits deze is gebaseerd op de meest recente stand van de wetenschap en praktijk en binnen de kaders die de Wet aangeeft; b. moet gebalanceerd en genuanceerd zijn; c. mag niet misleidend zijn.",
    category: "Reclame"
  },
  "5.7.2": {
    number: "5.7.2",
    header: "Verantwoordelijke en datum wijziging",
    text: "Iedere uiting met informatie over een bepaald geneesmiddel moet in ieder geval bevatten: a. de naam en het adres van de verantwoordelijke voor de informatie; b. de datum waarop de informatie voor het laatst is bijgewerkt.",
    category: "Reclame"
  },
  "5.8.1": {
    number: "5.8.1",
    header: "Definitie van informatie",
    text: "In deze paragraaf wordt onder informatie verstaan: informatie waarin direct of indirect wordt verwezen naar een receptgeneesmiddel.",
    category: "Reclame"
  },
  "5.8.2": {
    number: "5.8.2",
    header: "Niet oproepen tot angst",
    text: "Informatie mag geen gevoelens van angst of bijgelovigheid aanjagen of versterken en dient realistisch te worden weergegeven. De informatie mag geen onterechte, onnodig afschrikwekkende of bedrieglijke afbeeldingen bevatten van veranderingen van het menselijk lichaam ten gevolge van ziekte of letsel. Evenmin zijn dergelijke afbeeldingen toegestaan voor de werking van een behandelmethode van het menselijk lichaam.",
    category: "Reclame"
  },
  "5.8.3": {
    number: "5.8.3",
    header: "Begrijpelijke taal",
    text: "Informatie dient in een voor de gemiddelde consument begrijpelijke taal te zijn gesteld. Medische en wetenschappelijke terminologie moet zoveel mogelijk worden vermeden, teneinde verwarring of onduidelijkheid te voorkomen.",
    category: "Reclame"
  },
  "5.8.4": {
    number: "5.8.4",
    header: "Voorkomen irrationeel gebruik",
    text: "Informatie mag niet: a. aanzetten tot het irrationeel gebruik van receptgeneesmiddelen of tot het zoeken naar onnodige behandeling van ziekten; b. (in)direct leiden tot één bepaalde keuze uit verschillende relevante behandelingen; c. tot doel of gevolg hebben het publiek ervan te weerhouden of onnodig aan te moedigen een medische behandeling of behandeladvies te zoeken of nader medisch onderzoek te laten verrichten; d. de suggestie bevatten dat de normale goede gezondheid wordt verbeterd dan wel wordt verslechterd of aangetast door het (wel of niet) gebruiken van een receptgeneesmiddel; e. vermeldingen bevatten die, door bijvoorbeeld beschrijving of gedetailleerde presentatie van een ziektegeschiedenis, zou kunnen leiden tot een verkeerde zelfdiagnose.",
    category: "Reclame"
  },
  "5.8.5": {
    number: "5.8.5",
    header: "Gebruik van tests",
    text: "Het gebruik van een of meer verschillende tests, waaronder vragenlijsten, voor zelfdiagnose van ziekte is alleen toegestaan indien deze wetenschappelijk zijn gevalideerd en verifieerbaar zijn.",
    category: "Reclame"
  },
  "5.8.6": {
    number: "5.8.6",
    header: "Informatie aan kinderen",
    text: "Informatie gericht uitsluitend of voornamelijk op kinderen dient omzichtig te worden weergegeven, zodanig dat de informatie kinderen niet aanspoort om een behandelmethode te gebruiken, noch kinderen aanspoort hun ouders/verzorgers tot de behandelmethode aan te zetten.",
    category: "Reclame"
  },
  "5.8.7": {
    number: "5.8.7",
    header: "Geen vergelijkingen",
    text: "Er worden géén vergelijkingen met andere relevante behandelingen en geneesmiddelen gemaakt die suggereren dat de werking van een behandeling of receptgeneesmiddel beter is dan of gelijk is aan de werking van een andere relevante behandeling of van een ander relevant geneesmiddel.",
    category: "Reclame"
  },
  "5.8.8": {
    number: "5.8.8",
    header: "Testimonials",
    text: "Testimonials dienen een oprechte weergave te zijn van de mening of ervaring van de gebruiker (niet zijnde een beroepsbeoefenaar of andere bij het publiek bekende personen) en mogen geen vergelijkingen van de situatie voor en na de behandeling met een geneesmiddel bevatten.",
    category: "Reclame"
  },
  "5.8.9": {
    number: "5.8.9",
    header: "Evenwichtig en compleet",
    text: "Informatie dient evenwichtig en zo compleet mogelijk te worden weergegeven. De volgende criteria gelden voor een evenwichtige en zo compleet mogelijke opsomming van relevante behandelingen, waaronder het opsommen van receptgeneesmiddelen: a. Technische gebruikersinformatie van geneesmiddelen, zoals bijvoorbeeld dosering, contra-indicaties, bijwerkingen etc., worden compleet voor alle producten of voor geen enkel product gegeven; Indien bijvoorbeeld merknamen of vergoedingsstatus van receptgeneesmiddelen wordt genoemd, dan moet dit voor alle receptgeneesmiddelen op dezelfde wijze gebeuren. Indien van toepassing wordt naast de merknaam altijd de stofnaam genoemd. b. Géén enkele optie voor behandeling wordt geaccentueerd weergegeven, bijvoorbeeld door het gebruik van woorden, kleuren of beelden, gebruik van verschillende fonts, markeringen of andersoortige middelen of elementen; c. De positieve en negatieve eigenschappen van géén enkele behandeling mogen worden geaccentueerd zodanig dat het de nadelen of voordelen van een behandeling benadrukt; d. Het categoriseren van behandelingen moet op grond van algemeen aanvaardbare indelingen. Bijvoorbeeld het categoriseren op alfabet, therapeutische klassen of categorieën, of op behandelrichtlijnen mag wel, het categoriseren op meest recent geïntroduceerd waardoor de indruk of suggestie wordt gewekt: 'nieuw is beter' of meest gebruikte behandeling of receptgeneesmiddel, mag niet.",
    category: "Reclame"
  },
  "5.8.10": {
    number: "5.8.10",
    header: "Informatie aan een patiënt of verzorger of zorgprofessional",
    text: "Voor informatie aan een patiënt die een receptgeneesmiddel heeft voorgeschreven gekregen en eventuele verzorgers van de patiënt dan wel zorgprofessionals die zijn betrokken bij de toediening van het receptgeneesmiddel, geldt als uitzondering op artikelen 5.8.4 onder b en 5.8.9 dat bij het geven van informatie over het ziektebeeld en het betreffende receptgeneesmiddel, alleen die relevante factoren hoeven te worden meegenomen die voor een optimale behandeling met dat specifieke receptgeneesmiddel nodig zijn. Deze informatie moet zodanig worden verstrekt dat deze niet voor het algemene publiek toegankelijk is.",
    category: "Reclame"
  },
  "5.8.11": {
    number: "5.8.11",
    header: "Wetenschappelijke studies",
    text: "Informatie mag verwijzingen bevatten naar wetenschappelijke studies en resultaten, mits deze uit algemeen wetenschappelijk aanvaarde gepubliceerde artikelen komen. Hierbij dient altijd de bron te worden vermeld. De studies en resultaten waarnaar verwezen wordt dienen hoofdzakelijk te komen van andere bronnen dan van de vergunninghouder en dienen verifieerbaar te zijn. Selectieve verwijzing is niet toegestaan.",
    category: "Reclame"
  },
  "5.8.12": {
    number: "5.8.12",
    header: "Internet",
    text: "Het gebruik van de naam van een vergunninghouder, een indicatie en/of een merk van een receptgeneesmiddel in een internetadres is toegestaan. Ook mag een merk van een receptgeneesmiddel worden genoemd op corporate websites. Websites met de merknaam in het internetadres en zogenaamde 'corporate' sites (websites over de vergunninghouder in het algemeen) mogen uitsluitend technische gebruikersinformatie bevatten, zoals bijvoorbeeld de SPC van het geneesmiddel of de patiëntenbijsluiter. Op deze websites mag slechts beknopte ziektebeeldinformatie worden gegeven, die ondergeschikt is van aard en bijdraagt aan een goed begrip van de aandoening waarvoor de fabrikant een receptgeneesmiddel op de markt brengt.",
    category: "Reclame"
  },
  "5.9.1": {
    number: "5.9.1",
    header: "Wetenschappelijke dienst",
    text: "Vergunninghouders dragen zorg voor het beschikbaar zijn van een wetenschappelijke dienst, die wordt belast met de voorlichting over de geneesmiddelen, die door de vergunninghouder in de handel worden gebracht alsmede met de interne inhoudelijke toetsing van de reclame voor die geneesmiddelen aan hetgeen in deze Gedragscode is bepaald.",
    category: "Reclame",
  },
  "5.9.2": {
    number: "5.9.2",
    header: "Gekwalificeerde personen",
    text: "De werkzaamheden van de betreffende wetenschappelijke dienst worden verricht, binnen hun eigen beroepsmatige verantwoordelijkheid, door daartoe gekwalificeerde personen. Die werkzaamheden zullen, al dan niet in dienstverband, in opdracht van de betrokken vergunninghouder worden verricht.",
    category: "Reclame"
  },
  "6.1.1": {
    number: "6.1.1",
    header: "Verbod op gunstbetoon",
    text: "Gunstbetoon is verboden tenzij wordt beantwoord aan de gedragsregels van dit Hoofdstuk.",
    category: "Algemene Regels"
  },
  "6.1.2": {
    number: "6.1.2",
    header: "Onderscheid tussen gunstbetoon en andere financiële relaties",
    text: "Gunstbetoon is een financiële relatie die zich kenmerkt door het kennelijke doel het voorschrijven, ter hand stellen of gebruik van een geneesmiddel te bevorderen. Of daarvan sprake is moet van geval tot geval worden beoordeeld, waarbij de volgende factoren een rol kunnen spelen: a. de invloed en betrokkenheid van de begunstigde op het voorschrijven, ter hand stellen of gebruiken van een geneesmiddel; b. het doel van de financiële relatie in relatie tot het voorschrijven, ter hand stellen of gebruiken van een geneesmiddel; c. de omvang van de op geld waardeerbare vergoeding in verhouding tot het doel van de financiële relatie.",
    category: "Algemene Regels"
  },
  "6.1.3": {
    number: "6.1.3",
    header: "Wederkerigheid verbod gunstbetoon",
    text: "Van de beroepsbeoefenaar of andere begunstigde wordt verwacht dat hij bij het aangaan van een financiële relatie nagaat of deze in overeenstemming is met deze Gedragscode. Met het verbod op gunstbetoon uit hoofde van artikel 6.1.1 wordt gelijkgesteld het doen van een aanbod om verboden gunstbetoon dan wel het aanvaarden daarvan na een dergelijk aanbod.",
    category: "Algemene Regels"
  },
  "6.2.1": {
    number: "6.2.1",
    header: "Geschenken",
    text: "Vergunninghouders onthouden zich met betrekking tot beroepsbeoefenaren van: a. het aanbieden of in het vooruitzicht stellen van geschenken in welke vorm ook; b. het aanbieden of in het vooruitzicht stellen van kwijting voor de betaling van facturen, anders dan tegen volledige betaling, zulks onverminderd artikel 6:127 BW; c. het afhankelijk stellen van de prijs van geneesmiddelen van afname van andere geneesmiddelen of van andere producten; d. het aanbieden of in het vooruitzicht stellen van andere premies of voordelen in geld of natura; e. ieder ander handelen of nalaten waardoor afleveraars en voorschrijvers zich op onoorbare wijze tegenover de ondernemingen verplicht zouden voelen.",
    category: "Geschenken"
  },
  "6.2.2": {
    number: "6.2.2",
    header: "Geschenken van geringe waarde",
    text: "Van het bepaalde in artikel 6.2.1 zijn uitgezonderd geschenken of voordelen in geld of in natura, die een geringe waarde hebben en tevens van betekenis zijn voor de uitoefening van de praktijk van de beroepsbeoefenaar. Aangenomen wordt dat een geschenk van geringe waarde is wanneer de waarde niet meer bedraagt dan € 50 per keer, met een maximum van € 150 per jaar. Deze bedragen gelden per beroepsbeoefenaar en per vergunninghouder.",
    category: "Geschenken"
  },
  "6.2.3": {
    number: "6.2.3",
    header: "Kortingen",
    text: "Vergunninghouders onthouden zich bij de levering van geneesmiddelen van het aanbieden of verstrekken aan beroepsbeoefenaren van kortingen in de vorm van geschenken. Deze bepaling is niet van toepassing op kortingen verleend in verband met de levering van geneesmiddelen mits, in geval van kortingen in natura, in de vorm van bonusleveranties van hetzelfde geneesmiddel, respectievelijk in geval van korting in geld, indien deze uitdrukkelijk schriftelijk tot uitdrukking zijn gebracht.",
    category: "Geschenken"
  },
  "6.2.4": {
    number: "6.2.4",
    header: "Het verstrekken van monsters",
    text: "Vergunninghouders houden een adequate administratie bij van de door hen verstrekte monsters van geneesmiddelen en van de voorschrijvende beroepsbeoefenaren aan wie zij de monsters hebben verstrekt, op welke datum, alsmede in welke hoeveelheden. Voor deze administratie geldt een bewaartermijn van vijf (5) jaar.",
    category: "Monsters"
  },
  "6.3.1": {
    number: "6.3.1",
    header: "Dienstverlening",
    text: "Dienstverlening verricht door een beroepsbeoefenaar in opdracht van een vergunninghouder dient van belang te zijn voor de uitoefening van de geneeskunst, de farmacie, de tandheelkunst, de verpleegkunst of de verloskunst. Vergunninghouders dragen er zorg voor dat de honorering van beroepsbeoefenaren voor verleende diensten in een redelijke verhouding staat tot de door de beroepsbeoefenaren geleverde prestaties.",
    category: "Dienstverlening"
  },
  "6.3.2": {
    number: "6.3.2",
    header: "Schriftelijke overeenkomst",
    text: "De dienstverlening (met inbegrip van de te verrichten diensten en tegenprestatie) moet vooraf schriftelijk in één overeenkomst zijn vastgelegd waarin de doelstelling, uitvoering en de vergoeding van de te verlenen dienst helder dienen te zijn omschreven. Deze eis geldt niet voor overeenkomsten die enkel strekken tot het eenmalig invullen van eenvoudige vragenlijsten dan wel enquêteformulieren.",
    category: "Dienstverlening"
  },
  "6.3.3": {
    number: "6.3.3",
    header: "Redelijke vergoeding",
    text: "De te betalen tegenprestatie dient in redelijke verhouding te staan tot de te verrichten werkzaamheden. De werkelijk gemaakte kosten komen voor vergoeding in aanmerking. Daarnaast is een vergoeding op zijn plaats voor de tijd die de beroepsbeoefenaar heeft besteed. Deze vergoeding wordt bepaald aan de hand van de naar redelijke schatting aan de betrokken werkzaamheden verbonden tijdsbesteding en een redelijk uurtarief.",
    category: "Dienstverlening"
  },
  "6.3.4": {
    number: "6.3.4",
    header: "Passende locatie",
    text: "Samenkomsten die plaatsvinden in het kader van een dienstverleningsovereenkomst, dienen te voldoen aan het beginsel passende locatie van artikel 6.4.1.",
    category: "Dienstverlening"
  },
  "6.3.5": {
    number: "6.3.5",
    header: "Onderzoek waarbij geneesmiddelen zijn betrokken",
    text: "Deze Gedragscode is ook van toepassing op onderzoek waarbij geneesmiddelen zijn betrokken, tenzij sprake is van wetenschappelijk onderzoek dat valt onder de reikwijdte van de Wet medisch-wetenschappelijk onderzoek met mensen (WMO) of het Normenkader niet-WMO-plichtig onderzoek.",
    category: "Onderzoek"
  },
  "6.4.1": {
    number: "6.4.1",
    header: "Gastvrijheid bij bijeenkomsten en manifestaties",
    text: "Vergunninghouders dragen er zorg voor dat bij het verlenen van gastvrijheid aan beroepsbeoefenaren in het kader van bijeenkomsten en manifestaties deze gastvrijheid beperkt blijft tot hetgeen strikt noodzakelijk is voor de deelname aan de bijeenkomst of manifestatie en strikt beperkt blijft tot het met de bijeenkomst of manifestatie beoogde doel.",
    category: "Gastvrijheid"
  },
  "6.4.2": {
    number: "6.4.2",
    header: "Verpleegkundigen",
    text: "Bij het verlenen van gastvrijheid in het kader van bijeenkomsten, wordt onder beroepsbeoefenaar tevens verstaan een verpleegkundige die in de uitoefening van zijn beroep in opdracht van een arts, tandarts of verloskundige geneesmiddelen toedient of verstrekt aan patiënten.",
    category: "Gastvrijheid"
  },
  "6.4.3": {
    number: "6.4.3",
    header: "Verlenen van gastvrijheid",
    text: "Onder het verlenen van gastvrijheid wordt verstaan de vergoeding of het voor rekening nemen van reis-, verblijf- en deelnamekosten van een bijeenkomst/manifestatie. De geboden gastvrijheid mag geen ontspanning (sport, vrije tijdsbesteding en dergelijke) omvatten.",
    category: "Gastvrijheid"
  },
  "6.4.4": {
    number: "6.4.4",
    header: "Sponsoring van een bijeenkomst/manifestatie",
    text: "De eisen die aan het verlenen van gastvrijheid in artikel 6.4.1 worden gesteld gelden niet alleen voor bijeenkomsten of manifestaties die direct of indirect door de vergunninghouder worden georganiseerd, maar ook voor bijeenkomsten of manifestaties die direct of indirect door de vergunninghouder worden gesponsord.",
    category: "Gastvrijheid"
  },
  "6.4.5": {
    number: "6.4.5",
    header: "Bijeenkomsten",
    text: "Van een bijeenkomst is sprake in het geval dat de inhoud van de bijeenkomst wetenschappelijk is aangemerkt door een erkende instantie, of wanneer de organisatie in handen is van een onafhankelijke groepering of vergunninghouder, waarbij het programma en de objectiviteit van de presentaties voldoen aan onafhankelijke informatiebehoeften.",
    category: "Gastvrijheid"
  },
  "6.4.6": {
    number: "6.4.6",
    header: "Binnen redelijke perken bij bijeenkomsten",
    text: "De kosten van gastvrijheid per beroepsbeoefenaar bedragen niet meer dan € 500 per keer en € 1.500 per jaar, of de beroepsbeoefenaar draagt tenminste 50% van alle kosten zelf. Afspraken moeten schriftelijk worden vastgelegd, tenzij het enkel deelnamekosten betreft.",
    category: "Gastvrijheid"
  },
  "6.4.7": {
    number: "6.4.7",
    header: "Manifestaties",
    text: "Samenkomsten met een programma dat voorziet in informatiebehoeften van beroepsbeoefenaren die geen bijeenkomst zijn in de zin van artikel 6.4.5, zijn manifestaties.",
    category: "Gastvrijheid"
  },
  "6.4.8": {
    number: "6.4.8",
    header: "Binnen redelijke perken bij manifestaties",
    text: "De kosten van gastvrijheid per beroepsbeoefenaar bedragen niet meer dan € 75 per keer en € 375 per jaar. Afspraken moeten schriftelijk worden vastgelegd, tenzij het enkel deelnamekosten betreft.",
    category: "Gastvrijheid"
  },
  "6.4.9": {
    number: "6.4.9",
    header: "Samenkomsten in het buitenland",
    text: "Indien de gastvrijheid ziet op een bijeenkomst/manifestatie die plaatsvindt in het buitenland, dient deze bijeenkomst/manifestatie vooraf ter goedkeuring aan de Codecommissie te worden voorgelegd. Vrijgesteld zijn buitenlandse bijeenkomsten die daadwerkelijk een internationaal karakter hebben.",
    category: "Gastvrijheid"
  },
  "6.5.1": {
    number: "6.5.1",
    header: "Financiële relaties anders dan gunstbetoon",
    text: "De volgende financiële relaties van een vergunninghouder vallen in ieder geval buiten het begrip gunstbetoon ex artikel 3.1 onderdeel j: a. Relaties met anderen dan beroepsbeoefenaren als bepaald in artikel 6.5.2; b. Sponsoring van projecten als bepaald in artikel 6.5.3; c. Het (mede) mogelijk maken van wetenschappelijke prijzen als bepaald in artikel 6.5.4.",
    category: "Financiële Relaties"
  },
  "6.5.2": {
    number: "6.5.2",
    header: "Relaties met niet-beroepsbeoefenaren",
    text: "Indien wordt voldaan aan elk van de volgende voorwaarden, wordt vermoed dat een financiële relatie van een vergunninghouder met anderen dan beroepsbeoefenaren valt onder artikel 6.5.1 onder a: a. de relatie dient een gezondheidsbelang of behoort anderszins tot het normale rechtsverkeer; b. de relatie leidt er niet toe dat de begunstigde direct of indirect wordt beïnvloed om het voorschrijven, ter hand stellen of gebruik van geneesmiddelen te bevorderen; c. de aard en inhoud van de relatie gaan niet verder dan noodzakelijk om het doel te bereiken; d. de relatie vindt op integere, eerlijke en transparante wijze plaats en wordt vooraf schriftelijk vastgelegd; e. de relatie leidt niet tot aantasting van onafhankelijkheid, betrouwbaarheid of geloofwaardigheid van de begunstigde; f. de vergoeding blijft beperkt tot hetgeen strikt noodzakelijk is.",
    category: "Financiële Relaties"
  },
  "6.5.3": {
    number: "6.5.3",
    header: "Sponsoring",
    text: "Indien wordt voldaan aan elk van de volgende voorwaarden, wordt vermoed dat sponsoring van een project door een vergunninghouder valt onder artikel 6.5.1 onder b: a. de sponsoring heeft betrekking op innovatieve en/of kwaliteitsverbeterende activiteiten; b. de sponsoring heeft de directe of indirecte verbetering van zorg aan patiënten of de bevordering van de medische wetenschap tot doel; c. de sponsoring wordt verstrekt aan rechtspersonen; d. de sponsoring verplicht niet tot het voorschrijven, ter hand stellen of gebruik van geneesmiddelen; e. de aard en inhoud van de relatie gaan niet verder dan noodzakelijk; f. de sponsoring vindt op integere, eerlijke en transparante wijze plaats; g. de sponsoring mag geen prestatieplicht vereisen, behoudens naamsvermelding van de vergunninghouder; h. de sponsoring mag niet leiden tot aantasting van onafhankelijkheid, betrouwbaarheid en geloofwaardigheid.",
    category: "Sponsoring"
  },
  "6.5.4": {
    number: "6.5.4",
    header: "Wetenschappelijke prijzen",
    text: "Onder een wetenschappelijke prijs wordt verstaan het toekennen van geld of op geld waardeerbare goederen of diensten voor een zorgverbeterende en/of medisch-wetenschappelijke prestatie waarmee de begunstigde zich heeft onderscheiden. Indien wordt voldaan aan elk van de volgende voorwaarden, wordt vermoed dat de bijdrage aan een wetenschappelijke prijs valt onder artikel 6.5.1 onder c: a. de prestatie wordt beoordeeld door een onafhankelijke deskundige jury; b. de onafhankelijkheid van de wetenschappelijke prijs is gewaarborgd; c. de bijdrage vindt op integere, eerlijke en transparante wijze plaats; d. de bijdrage leidt niet tot aantasting van betrouwbaarheid en geloofwaardigheid; e. de omvang van de prijs staat in redelijke verhouding tot het doel ervan.",
    category: "Wetenschappelijke Prijzen"
  },
  "6.6.1": {
    number: "6.6.1",
    header: "Definitie patiëntenorganisatie",
    text: "Onder patiëntenorganisatie wordt verstaan: een non-profit organisatie die overwegend is samengesteld uit patiënten en/of verzorgers van patiënten of andere verzorgers vertegenwoordigen.",
    category: "Patiëntenorganisaties"
  },
  "6.6.2": {
    number: "6.6.2",
    header: "Ondersteuning is toegestaan",
    text: "Ondersteuning van een activiteit van de patiëntenorganisatie in de vorm van subsidiëring of sponsoring is toegestaan mits de voorwaarden van artikel 6.5.3 worden nageleefd, en: a. directe of indirecte reclame voor specifieke receptgeneesmiddelen is verboden; b. de informatie over receptgeneesmiddelen moet voldoen aan paragrafen 5.7 en 5.8.",
    category: "Patiëntenorganisaties"
  },
  "6.6.3": {
    number: "6.6.3",
    header: "Schriftelijke overeenkomst",
    text: "De ondersteuning van een vergunninghouder van een activiteit van de patiëntenorganisatie dient te worden vastgelegd in een schriftelijke overeenkomst die bevat: a. de doelstelling van de ondersteuning; b. een omschrijving van de rechten en verplichtingen van beide partijen; c. de omvang van de ondersteuning in euro's; d. de verplichting voor de patiëntenorganisatie te communiceren dat de activiteit mogelijk is gemaakt door de vergunninghouder.",
    category: "Patiëntenorganisaties"
  },
  "6.6.4": {
    number: "6.6.4",
    header: "Dienstverlening",
    text: "Indien de vergunninghouder met de patiëntenorganisatie een dienstverleningsovereenkomst aangaat, dient deze te voldoen aan de voorwaarden van artikel 6.5.2.",
    category: "Patiëntenorganisaties"
  },
  "6.6.5": {
    number: "6.6.5",
    header: "Gastvrijheid",
    text: "Indien in het kader van de ondersteuning sprake is van een samenkomst waarbij de vergunninghouder gastvrijheid verleent aan (vertegenwoordigers van) de patiëntenorganisatie, dient deze gastvrijheid: a. beperkt te blijven tot hetgeen strikt noodzakelijk is; b. ondergeschikt te zijn aan het hoofddoel van de samenkomst; c. zich slechts uit te strekken tot de deelnemers aan het inhoudelijke gedeelte; d. niet het kennelijke doel te hebben het gebruik van geneesmiddelen te bevorderen; e. plaats te vinden op een passende locatie.",
    category: "Patiëntenorganisaties"
  },
  "6.6.6": {
    number: "6.6.6",
    header: "Verzorger",
    text: "Als uitzondering op artikel 6.6.5 onder c is het de vergunninghouder toegestaan gastvrijheid te verlenen aan de verzorger van een bij de patiëntenorganisatie aangesloten patiënt, mits de gezondheidstoestand van deze patiënt de begeleiding van deze verzorger vereist.",
    category: "Patiëntenorganisaties"
  },
  "7.1.1": {
    number: "7.1.1",
    header: "Transparantie",
    text: "Vergunninghouders enerzijds en beroepsbeoefenaren, samenwerkingsverbanden van beroepsbeoefenaren en instellingen waarin beroepsbeoefenaren participeren dan wel werkzaam zijn en patiëntenorganisaties anderzijds, zijn transparant over hun relaties die mogelijk kunnen leiden tot belangenverstrengeling, overeenkomstig de daarvoor vastgestelde gedragsregels. De Gedragscode onderscheidt drie vormen van transparantie: a. Herkenbaarheid van relaties en posities. b. Interne melding bij respectievelijk voorafgaande goedkeuring van de Raad van Bestuur van een instelling. c. Openbaarmaking in het Transparantieregister Zorg.",
    category: "Transparantie"
  },
  "7.1.2": {
    number: "7.1.2",
    header: "Herkenbaarheid van relaties en posities",
    text: "1. De organisator van een bijeenkomst die met financiële ondersteuning van een of meerdere vergunninghouders tot stand komt, dient dit duidelijk van tevoren en tijdens de bijeenkomst kenbaar te maken. 2. Patiëntenorganisaties die een activiteit organiseren die (mede) wordt gefinancierd door een of meer vergunninghouders, dienen duidelijk te communiceren dat die activiteit (mede) mogelijk is gemaakt door de betreffende sponsor(s).",
    category: "Transparantie"
  },
  "7.1.3": {
    number: "7.1.3",
    header: "Openbaarmaking banden",
    text: "Banden tussen beroepsbeoefenaren die optreden als opdrachtnemer voor vergunninghouders of derde partijen en die mogelijk kunnen leiden tot belangenverstrengeling, dienen door de beroepsbeoefenaar in mondelinge of schriftelijke presentaties openbaar te worden gemaakt.",
    category: "Transparantie"
  },
  "7.1.4": {
    number: "7.1.4",
    header: "Herkenbaarheid vertegenwoordigers vergunninghouder",
    text: "Vertegenwoordigers van een vergunninghouder dienen in hun optreden als zodanig herkenbaar te zijn, bijvoorbeeld door het dragen van een badge tijdens bijeenkomsten en/of manifestaties.",
    category: "Transparantie"
  },
  "7.1.5": {
    number: "7.1.5",
    header: "Interne transparantie",
    text: "1. Beroepsbeoefenaren dienen afspraken over verleende gastvrijheid te melden aan de Raad van Bestuur van de instelling waarin zij werkzaam zijn. 2. Dienstverleningsovereenkomsten met een vergunninghouder dienen vooraf toestemming te verkrijgen van het bevoegde bestuur van de relevante instelling. 3. Sponsoringsovereenkomsten met een vergunninghouder dienen eveneens vooraf toestemming te verkrijgen van het bevoegde bestuur. 4. De toestemming blijkt uit medeondertekening van de betrokken overeenkomst. 5. Indien van toepassing doet de beroepsbeoefenaar melding van de overeenkomst bij andere instellingen waar hij/zij werkzaam is.",
    category: "Transparantie"
  },
  "7.2.1": {
    number: "7.2.1",
    header: "Openbaarmaking in Transparantieregister Zorg",
    text: "In het Transparantieregister Zorg dienen de volgende categorieën financiële relaties openbaar te worden gemaakt: a. dienstverleningsovereenkomsten; b. overeenkomsten inzake bijdragen in gastvrijheidskosten; c. sponsoring van samenkomsten; d. sponsoring van projecten, wetenschappelijke prijzen of patiëntenorganisaties. De openbaarmaking geldt alleen als het totale bedrag hoger is dan €500 per kalenderjaar.",
    category: "Transparantieregister"
  },
  "7.2.2": {
    number: "7.2.2",
    header: "Openbaar te maken gegevens",
    text: "De volgende gegevens dienen in het Transparantieregister Zorg openbaar te worden gemaakt: a. de aard van de financiële relatie; b. het kalenderjaar; c. de naam van de vergunninghouder; d. de naam van de ontvanger en het BIG- of KvK-nummer; e. het betaalde bedrag.",
    category: "Transparantieregister"
  },
  "7.2.3": {
    number: "7.2.3",
    header: "Aanlevering gegevens",
    text: "De gegevens die openbaar moeten worden gemaakt, dienen jaarlijks door vergunninghouders te worden aangeleverd bij het Transparantieregister Zorg. Ontvangers worden voorafgaand aan de openbaarmaking in de gelegenheid gesteld de gegevens te verifiëren.",
    category: "Transparantieregister"
  },
  "7.2.4": {
    number: "7.2.4",
    header: "Duur openbaarmaking",
    text: "De openbaarmaking op grond van deze paragraaf geldt voor een periode van 3 jaar. Na deze termijn worden de gegevens door het Transparantieregister Zorg verwijderd.",
    category: "Transparantieregister"
  },
  "7.2.5": {
    number: "7.2.5",
    header: "Schriftelijke vastlegging",
    text: "In overeenkomsten als bedoeld in artikel 7.2.1 lid 1 dienen bepalingen te zijn opgenomen waarin de verplichtingen tot openbaarmaking in het Transparantieregister Zorg op grond van deze Gedragscode zijn vastgelegd.",
    category: "Transparantieregister"
  },
  "7.2.6": {
    number: "7.2.6",
    header: "Opvragen documenten",
    text: "De CGR kan documentatie opvragen die ten grondslag ligt aan de meldingen in het Transparantieregister Zorg. Vergunninghouders zijn verplicht medewerking te verlenen aan dergelijke verzoeken.",
    category: "Transparantieregister"
  },
  "8.1": {
    number: "8.1",
    header: "Inwerkingtreding Gedragscode",
    text: "Met inachtneming van artikel 8.3 treedt deze Gedragscode in werking met ingang van 16 mei 2014, met intrekking van de eerder geldende Gedragscode Geneesmiddelenreclame, Uitwerking Normen Gunstbetoon artikel 12 en 13, 16 tot en met 22 Gedragscode Geneesmiddelenreclame, Nadere uitwerking van artikel 16 en richtsnoeren interne procedure inzake niet-WMO-plichtig onderzoek, Nadere invulling van het onderscheid tussen reclame en informatie voor geneesmiddelen, Leidraad Informatie UR-geneesmiddelen, Gedragsregels Sponsoring, Richtlijnen onderbouwen vergelijkende claims, Gedragsregels inzake sponsoring van patiëntenorganisaties en Gedragsregels openbaarmaking financiële relaties van de Stichting CGR. Voor de behandeling van adviesaanvragen en klachten in eerste en tweede aanleg geldt de Gedragscode die gold op het moment van indiening van de adviesaanvraag c.q. klacht.",
    category: "Slotbepalingen"
  },
  "8.2": {
    number: "8.2",
    header: "Geldigheid eerdere beslissingen",
    text: "Alle beslissingen en adviesoordelen van de Codecommissie en de Commissie van Beroep van vóór 15 mei 2014, blijven ook onder de werking van deze Gedragscode van kracht.",
    category: "Slotbepalingen"
  }

};

// Helper functions for working with the articles
// Categories for easy reference
export const ARTICLE_CATEGORIES = {
  ALGEMEEN: "Algemeen",
  RECLAME: "Reclame",
  GUNSTBETOON: "Gunstbetoon",
  TRANSPARANTIE: "Transparantie",
  OVERIG: "Overig"
};

// Mapping of article prefixes to categories
export const CATEGORY_MAPPINGS = {
  "1.": "Algemeen",
  "2.": "Algemeen",
  "3.": "Algemeen",
  "4.": "Algemeen",
  "5.": "Reclame",
  "6.": "Gunstbetoon",
  "7.": "Transparantie",
  "8.": "Overig"
};

// Helper functions

/**
 * Search for articles based on a search term
 * @param {string} searchTerm - The term to search for
 * @param {number} threshold - Minimum relevance score (0-1)
 * @returns {Array} Array of matching articles with relevance scores
 */
export const searchArticles = (searchTerm, threshold = 0.3) => {
  const results = [];
  const searchTermLower = searchTerm.toLowerCase();

  Object.entries(codeArticles).forEach(([articleNumber, article]) => {
    const searchContent = `${article.header || ''} ${article.text}`.toLowerCase();

    let relevanceScore = 0;

    if (articleNumber.includes(searchTerm)) {
      relevanceScore += 1;
    }

    if (article.header?.toLowerCase().includes(searchTermLower)) {
      relevanceScore += 0.8;
    }

    if (article.text.toLowerCase().includes(searchTermLower)) {
      relevanceScore += 0.6;
    }

    if (relevanceScore > threshold) {
      results.push({
        articleNumber,
        article,
        relevanceScore
      });
    }
  });

  return results.sort((a, b) => b.relevanceScore - a.relevanceScore);
};

/**
 * Get all articles in a specific category
 * @param {string} category - The category to filter by
 * @returns {Object} Object containing matching articles
 */
export const getArticlesByCategory = (category) => {
  return Object.entries(codeArticles)
    .filter(([_, article]) => article.category === category)
    .reduce((acc, [key, article]) => ({ ...acc, [key]: article }), {});
};

/**
 * Get an article by its exact number
 * @param {string} articleNumber - The article number to look up
 * @returns {Object|undefined} The matching article or undefined
 */
export const getArticleByNumber = (articleNumber) => {
  return codeArticles[articleNumber];
};

/**
 * Get related articles based on an article number
 * @param {string} articleNumber - The base article number to find relations for
 * @returns {Array} Array of related articles
 */
export const getRelatedArticles = (articleNumber) => {
  const baseArticle = codeArticles[articleNumber];
  if (!baseArticle) return [];

  const sameCategory = Object.values(codeArticles)
    .filter(article =>
      article.category === baseArticle.category &&
      article.number !== articleNumber
    );

  const parentNumber = articleNumber.split('.').slice(0, -1).join('.');
  const sameParent = Object.values(codeArticles)
    .filter(article =>
      article.number.startsWith(parentNumber) &&
      article.number !== articleNumber
    );

  return [...new Set([...sameCategory, ...sameParent])];
};

/**
 * Format article text with proper line breaks and structure
 * @param {string} text - The article text to format
 * @returns {string} Formatted text
 */
export const formatArticleText = (text) => {
  return text
    .replace(/([a-z])\.\s([A-Z])/g, '$1.\n\n$2')
    .replace(/([a-z])\n([a-z])/g, '$1 $2')
    .trim();
};


export const getArticleContent = (articleData, reference) => {
  if (!articleData || !reference) return null;

  // Extract the base article number and subsection
  const [baseArticle, ...rest] = reference.split(' ');
  const hasSubsection = rest.join(' ').toLowerCase().includes('onder');

  if (!hasSubsection) {
    return {
      header: articleData.header,
      content: articleData.text
    };
  }

  // Extract subsection letter
  const subsectionLetter = rest.join(' ').toLowerCase().split('onder')[1].trim();

  if (articleData.subsections && articleData.subsections[subsectionLetter]) {
    return {
      header: `${articleData.header} - ${subsectionLetter}`,
      introduction: articleData.introduction,
      content: articleData.subsections[subsectionLetter]
    };
  }

  // Fallback to full text if subsection not found
  return {
    header: articleData.header,
    content: articleData.text
  };
};

// Add categories to all articles
Object.entries(codeArticles).forEach(([number, article]) => {
  const prefix = number.split('.')[0] + '.';
  if (!article.category) {
    article.category = CATEGORY_MAPPINGS[prefix] || ARTICLE_CATEGORIES.OVERIG;
  }
});